__turbopack_context__.v({
  "icon": "ToolbarIconControl-module__Yw0IFW__icon",
  "line": "ToolbarIconControl-module__Yw0IFW__line",
  "text": "ToolbarIconControl-module__Yw0IFW__text",
});
